import _axios from "../../index";
//人脸识别
export const faceApply = data =>
    _axios({
        url: `identification/personal/face/h5/apply`,
        method: "get",
        params: data
    });

//人脸识别回调
export const faceCallback = data =>
    _axios({
        url: `identification/personal/face/h5/callback`,
        method: "get",
        params: data
    });

//人脸状态
export const faceStatus = data =>
    _axios({
        url: `identification/personal/face/status`,
        method: "get",
        params: data
    });